import reloadWindow from './reloadWindow';

export default reloadWindow;
